import { gql } from '@apollo/client';

export const readAllNotificationsMutation = gql`
  mutation readAllNotifications {
    readAllNotifications
  }
`;
